import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DispositionRoutingModule } from './dispositions-routing.module';
import { DispositionsIndexComponent } from './index.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { ProjectsSharedModule } from '../../@shared/projects-shared.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FilesCommentsFormModule } from 'app/shared/modules/files-comments-form/files-comments-form.module';
import { DirectivesModule } from '@shared/directives/directives.module';

@NgModule({
  declarations: [DispositionsIndexComponent],
  imports: [
    CommonModule,
    DispositionRoutingModule,
    MatButtonModule,
    MatIconModule,
    MatChipsModule,
    MatTooltipModule,
    MatMenuModule,
    MatTableModule,
    MatProgressBarModule,
    ProjectsSharedModule,
    FilesCommentsFormModule,
    DirectivesModule,
  ],
})
export class DispositionsModule {}
